// extracted by mini-css-extract-plugin
export default {"code":"TwoFactorAuthCode_code__ZzKk3","code__digit":"TwoFactorAuthCode_code__digit__n9cO7"};